import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Layout } from "../components/layout";
import { PatternEditor } from "../components/editor";
import { templates } from "../data/templates";

export function TemplateEditorPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const template = templates.find((t) => t.id === id);

  if (!template) {
    return (
      <Layout fullWidth>
        <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-white mb-4">
              Template not found
            </h1>
            <p className="text-gray-400 mb-8">
              The template you're looking for doesn't exist.
            </p>
            <button
              onClick={() => navigate("/templates")}
              className="px-4 py-2 bg-volt-blue text-white rounded-lg hover:bg-volt-green transition-colors"
            >
              Back to Templates
            </button>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout fullWidth>
      <PatternEditor
        title={template.title}
        description={template.description}
        initialPattern={template.pattern}
        isTemplate={true}
      />
    </Layout>
  );
}
